import { useNavigate, useLocation } from "react-router-dom";
import { DiamondMark } from "./DiamondMark";
import { useAuth } from "../context/AuthContext";
import { Button } from "./ui/button";

const PLAN_LABEL = { free: "Seeker", ascendent: "Ascendent", luminous: "Luminous" };

export function Header() {
  const navigate = useNavigate();
  const location = useLocation();
  const { user, logout } = useAuth();
  const authed = user && user.user_id;

  const scrollTo = (id) => {
    if (location.pathname !== "/") {
      navigate("/#" + id);
      return;
    }
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <header className="fixed top-0 inset-x-0 z-50 cg-glass border-b border-[rgba(140,79,214,0.22)]">
      <div className="max-w-6xl mx-auto px-5 h-16 flex items-center justify-between">
        <button
          data-testid="logo-home-button"
          onClick={() => navigate("/")}
          className="flex items-center gap-2.5 group"
        >
          <DiamondMark size={26} className="transition-transform duration-500 group-hover:rotate-180" />
          <span className="font-serif text-lg tracking-tight text-cg-textp">ClearGlass<span className="text-cg-cyan">.ai</span></span>
        </button>

        <nav className="hidden md:flex items-center gap-7 text-sm text-cg-texts">
          <button data-testid="nav-how" onClick={() => scrollTo("how")} className="hover:text-cg-textp transition-colors">How it works</button>
          <button data-testid="nav-portals" onClick={() => scrollTo("portals")} className="hover:text-cg-textp transition-colors">Portals</button>
          <button data-testid="nav-pricing" onClick={() => navigate("/pricing")} className="hover:text-cg-textp transition-colors">Pricing</button>
          {authed && (
            <button data-testid="nav-app" onClick={() => navigate("/app")} className="hover:text-cg-textp transition-colors">Sessions</button>
          )}
          {authed && (
            <button data-testid="nav-metrics" onClick={() => navigate("/metrics")} className="hover:text-cg-textp transition-colors">Metrics</button>
          )}
          {authed && user.role === "admin" && (
            <button data-testid="nav-admin" onClick={() => navigate("/admin")} className="text-cg-gold hover:text-cg-gold/80 transition-colors">Admin</button>
          )}
        </nav>

        <div className="flex items-center gap-3">
          {authed ? (
            <>
              <button
                data-testid="plan-badge"
                onClick={() => navigate("/account")}
                className="hidden sm:inline-flex items-center gap-1.5 rounded-full border border-[rgba(92,200,240,0.4)] px-3 py-1 text-xs font-mono uppercase tracking-widest text-cg-cyan hover:bg-[rgba(92,200,240,0.08)] transition-colors"
              >
                {PLAN_LABEL[user.plan] || "Seeker"}
              </button>
              <Button
                data-testid="enter-app-button"
                onClick={() => navigate("/app")}
                className="rounded-full bg-cg-violet hover:bg-cg-violetglow text-white shadow-[0_0_20px_rgba(109,53,192,0.4)]"
              >
                Enter
              </Button>
              <Button
                data-testid="logout-button"
                variant="ghost"
                onClick={() => { logout(); navigate("/"); }}
                className="text-cg-texts hover:text-cg-textp"
              >
                Sign out
              </Button>
            </>
          ) : (
            <>
              <Button
                data-testid="header-signin-button"
                variant="ghost"
                onClick={() => navigate("/login")}
                className="text-cg-texts hover:text-cg-textp"
              >
                Sign in
              </Button>
              <Button
                data-testid="header-start-button"
                onClick={() => navigate("/login?mode=register")}
                className="rounded-full bg-cg-violet hover:bg-cg-violetglow text-white shadow-[0_0_20px_rgba(109,53,192,0.4)]"
              >
                Begin
              </Button>
            </>
          )}
        </div>
      </div>
    </header>
  );
}
